import { IAvailableFilter } from "components/filters";
import { actionFilterConfig } from "components/filters/action-filter/default-config";
import { agentFilterConfigMultiple, agentFilterConfigSingle } from "components/filters/agent-filter";
import { dateRangeFilterConfig } from "components/filters/date-range-filter";
import { groupFilterConfigMultiple } from "components/filters/group-filter";
import { languageFilterConfig } from "components/filters/language-filter/default-config";
import { priorityFilterConfig } from "components/filters/priority-filter";
import { tagFilterConfigMultiple } from "components/filters/tag-filter";
import { targetFilterConfig } from "components/filters/target-filter/default-config";
import { ticketSourceFilterConfig } from "components/filters/ticket-source-filter";
import { Filter } from "constants/filters";

import { ReportType } from "./report-type";

export const filters: { [key: string]: IAvailableFilter } = {
  dateRange: {
    filter: Filter.DateRange,
    config: {
      ...dateRangeFilterConfig,
      removable: false,
      withCompare: true,
    },
  },
  agent: {
    filter: Filter.Agent,
    config: {
      ...agentFilterConfigMultiple,
      withCompare: true,
    },
  },
  group: {
    filter: Filter.Group,
    config: {
      ...groupFilterConfigMultiple,
      withCompare: true,
    },
  },
  detailedSource: { filter: Filter.DetailedSource, config: ticketSourceFilterConfig },
  priority: { filter: Filter.Priority, config: priorityFilterConfig },
  tag: { filter: Filter.Tag, config: tagFilterConfigMultiple },
  action: { filter: Filter.Action, config: actionFilterConfig },
  target: { filter: Filter.Target, config: targetFilterConfig },
  author: { filter: Filter.Author, config: agentFilterConfigSingle },
  language: { filter: Filter.Language, config: languageFilterConfig },
};

export const reportsFilters: Partial<{ [key in ReportType]: Filter[] }> = {
  [ReportType.TicketRatings]: [
    Filter.DateRange,
    Filter.Agent,
    Filter.Group,
    Filter.Tag,
    Filter.Priority,
    Filter.DetailedSource,
    Filter.Language,
  ],
  [ReportType.SolvedAndClosed]: [
    Filter.DateRange,
    Filter.Agent,
    Filter.Group,
    Filter.Tag,
    Filter.Priority,
    Filter.DetailedSource,
    Filter.Language,
  ],
  [ReportType.TicketFirstResponseTime]: [
    Filter.DateRange,
    Filter.Agent,
    Filter.Group,
    Filter.Tag,
    Filter.Priority,
    Filter.DetailedSource,
    Filter.Language,
  ],
  [ReportType.NewTickets]: [Filter.DateRange, Filter.Group, Filter.Tag, Filter.Priority, Filter.Language],
  [ReportType.TicketResolutionTime]: [
    Filter.DateRange,
    Filter.Agent,
    Filter.Group,
    Filter.Tag,
    Filter.Priority,
    Filter.DetailedSource,
    Filter.Language,
  ],
  [ReportType.AuditLog]: [
    Filter.DateRange,
    Filter.Author,
    Filter.Action,
    Filter.Target,
    Filter.PageSize,
    Filter.NextId,
    Filter.PrevId,
    Filter.NextValue,
    Filter.PrevValue,
  ],
  [ReportType.HandlingTimeByStatus]: [
    Filter.DateRange,
    Filter.Agent,
    Filter.Priority,
    Filter.Tag,
    Filter.Group,
    Filter.DetailedSource,
    Filter.Language,
  ],
};
